export default {"src":"/_next/static/media/panel_regular.f15af52c.svg","height":24,"width":24};